var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 42C32.5229 42 37 37.2991 37 31.5C37 25.701 32.5229 21 27 21C21.4771 21 17 25.701 17 31.5C17 37.2991 21.4771 42 27 42Z",
    fill: "#FFB3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4921 9C8.81609 11.6467 6.13121 14.2859 3.44921 16.9277C2.85221 17.5155 2.85221 18.4787 3.44921 19.0664C6.14321 21.7131 8.8371 24.3611 11.5401 27L13.637 24.8613C11.8251 23.0663 9.99815 21.2854 8.17718 19.5H33.7521C38.3481 19.5 41.9991 23.1536 41.9991 27.75C41.9991 32.3464 38.3481 36 33.7521 36H3.00207V39H33.7521C39.956 39 44.9991 33.9565 44.9991 27.75C44.9991 21.5435 39.956 16.5 33.7521 16.5H8.15905C9.97105 14.7097 11.7831 12.9219 13.6011 11.1387L11.4921 9Z",
    fill: "#5A348C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.6b5e0c42707453ab1ea4e353094799fa.svg";
export { ForwardRef as ReactComponent };